export enum RequestActionsToLoad {
    DefaultView = 'DefaultView',
    RequestReturnView = 'RequestReturnView',
    RequestExtensionView = 'RequestExtensionView',
    RequestServiceView = 'RequestServiceView',
    RequestCloneContractView = 'RequestCloneContractView',
    SendDocumentsView = 'SendDocumentsView'
}
